var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25212 14.6663C11.934 14.6663 14.9188 11.6816 14.9188 7.99967C14.9188 4.31778 11.934 1.33301 8.25212 1.33301C4.57022 1.33301 1.58545 4.31778 1.58545 7.99967C1.58545 11.6816 4.57022 14.6663 8.25212 14.6663Z",
    stroke: "#f4fdfa",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31201 6.00038C6.46875 5.55483 6.77811 5.17912 7.18531 4.9398C7.59252 4.70049 8.07128 4.61301 8.5368 4.69285C9.00232 4.7727 9.42456 5.01473 9.72873 5.37607C10.0329 5.7374 10.1994 6.19473 10.1987 6.66705C10.1987 8.00038 8.19868 8.66705 8.19868 8.66705",
    stroke: "#f4fdfa",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25195 11.333H8.25904",
    stroke: "#f4fdfa",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3f6d8573201708a31895aa59108d16ab.svg";
export { ForwardRef as ReactComponent };